import { useId, useEffect, useRef, useState } from 'react'
import { useMermaid } from '../../hooks/useMermaid'

export default function MermaidBlock({ children }) {
  const { mermaid, ready } = useMermaid()
  const rawId = useId()
  const id = 'mermaid-' + rawId.replace(/:/g, '')
  const [svg, setSvg] = useState(null)
  const [error, setError] = useState(false)

  useEffect(() => {
    if (!ready || !mermaid.current) return

    mermaid.current.render(id, children)
      .then(({ svg: renderedSvg }) => {
        setSvg(renderedSvg)
      })
      .catch(() => {
        setError(true)
      })
  }, [ready, children, id])

  if (!ready) {
    return <div className="bg-zinc-800 animate-pulse rounded h-32 my-3" />
  }

  if (error) {
    return (
      <pre className="bg-zinc-800 rounded p-4 text-xs font-mono text-zinc-300 overflow-x-auto my-3">
        {children}
      </pre>
    )
  }

  if (!svg) {
    return <div className="bg-zinc-800 animate-pulse rounded h-32 my-3" />
  }

  return (
    <div dangerouslySetInnerHTML={{ __html: svg }} />
  )
}
